/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_TitleInputs */

const cs_sreality_seller_title = /** @type {(inputs: Sreality_Seller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Váš Sreality makléř`)
};

const en_sreality_seller_title = /** @type {(inputs: Sreality_Seller_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Sreality seller`)
};

/**
* | output |
* | --- |
* | "Your Sreality seller" |
*
* @param {Sreality_Seller_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_title = /** @type {((inputs?: Sreality_Seller_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_title(inputs)
	return cs_sreality_seller_title(inputs)
});